export const FETCH_SETTING = 'FETCH_SETTING';
export const CREATE_SETTING = 'CREATE_SETTING';
export const UPDATE_SETTING_A = 'UPDATE_SETTING_A';
export const FETCH_WEEKLY_SETTING_A = 'FETCH_WEEKLY_SETTING_A';
export const FETCH_USER_PAGE_MSG_A = 'FETCH_USER_PAGE_MSG_A';
